import cloneDeep from 'clone-deep'
import { accountTypeWithBorrower, InputType } from 'config'
import { useEffect, useState } from 'react'
import { loanTypeMap } from 'reducers/loanDetail.reducer'
import { Modal } from 'stories/components'
import { InputValidate } from 'utils'
import { RenderInput } from 'utils/RenderInput'

const defaultInputs = (): Record<string, InputType> => {
  return {
    accountTypes: {
      inputType: 'multiselect',
      title: 'Account Type',
      options: accountTypeWithBorrower(),
      defaultSelected: false,
      value: {},
      sort: true,
    },
    visibleLoanTypes: {
      inputType: 'multiselect',
      title: 'Visible by Channel',
      options: loanTypeMap,
      defaultSelected: true,
      value: {},
      sort: false,
    },
  }
}

export const VisibleSectionModal = ({
  data: defaultData,
  onClose,
  onOk: _onOk,
}: {
  data: Record<string, any>
  onClose: Function
  onOk: Function
}) => {
  const [inputs, setInputs] = useState(defaultInputs())

  useEffect(() => {
    const newInputs = cloneDeep(inputs)
    Object.keys(inputs).forEach((key) => (newInputs[key].value = defaultData[key]))
    setInputs(newInputs)
  }, [defaultData])

  const onChange = (key: string, value: any) => {
    const newInputs = cloneDeep(inputs)
    newInputs[key].value = value
    setInputs(newInputs)
  }

  const onOk = () => {
    let hasError = false
    let newInputs = cloneDeep(inputs)
    let newData: any = cloneDeep(defaultData) || {}

    Object.keys(inputs).map((key) => {
      const input = newInputs[key]
      if (input.visible === false) return

      newInputs[key].error = InputValidate({ ...input, value: input.value })
      if (newInputs[key].error?.length) hasError = true
      newData[key] = newInputs[key].value
    })
    setInputs(newInputs)
    if (hasError) return

    _onOk(newData)
  }

  return (
    <Modal title="Visible Properties" isOpen onClose={() => onClose()} onOk={onOk}>
      <div className="w-120 h-96">
        {Object.keys(inputs).map((key) => {
          return (
            <div key={key} className="mb-2">
              <RenderInput input={inputs[key]} Key={key} onChange={onChange} />
            </div>
          )
        })}
      </div>
    </Modal>
  )
}
